import { getCmsGroupBooking } from "../../../app/api/getCmsGroupBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { IFAQResponse } from "../../../Orchestrator/Types/Interface/ICmsGroupBooking";

class GetCmsGroupBookingAction extends BaseAction<
  IFAQResponse | null,
  void
> {
  override async run(): Promise<IFAQResponse | null> {
    let cmsResponse: IFAQResponse | null = null;

    try {
      const response: IApiResponse<IFAQResponse> =
        await getCmsGroupBooking();

      if (response.status === "ok" && response.answer) {
        cmsResponse = response.answer;
        updateRecoilState("cmsGroupBookingAtom", cmsResponse);

      } else {
        console.warn("Failed to fetch Group Booking data.");
      }
    } catch (error: any) {
      console.error("Error fetching Group Booking:", error);
    }

    return cmsResponse;
  }
}

export const getCmsGroupBookingAction =
  new GetCmsGroupBookingAction();